<script setup>
import MediaList from "@/components/media/MediaList.vue";
import axios  from "axios";
import moment  from "moment";
import { saveAs } from 'file-saver';
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

</script>
<template>
<v-dialog
	fullscreen
	v-model="medialist"
>
	<v-card>
		<v-toolbar
			flat
			color="#e11e32"
			dark
		>
			<v-toolbar-title>
				<span v-if="list_title != ''">{{ list_title }}</span>			
				<span v-else>候補BOX</span>			
			</v-toolbar-title>
			<v-spacer />
			<v-icon
				class="mr-3"
				v-if="list_id != '' && list_id != undefined"
				@click="download"
			>
				mdi-download
			</v-icon>
			<v-icon
				@click="medialist = false"
			>
				mdi-close
			</v-icon>
		</v-toolbar>
		<v-card-text>
			<MediaList :list_id="list_id" />
		</v-card-text>
	</v-card>
</v-dialog>
</template>
<script>
export default {
	props : ["list_id","list_title"],
	computed : {
		candlist : function(){
			return this.$store.getters["mediacand/get_candlist"];
		},
	},
	data : function(){
		return {
			medialist : false,
		};
	},
	methods : {
		open : function(){
			this.medialist = true;
		},
        download  : async function(){
            let params = new URLSearchParams();
			params.append("list_id",this.list_id);
            await axios.post("/api/media/get_media_list_download",params,{responseType: "blob"})
            .then(response => {
                const blob = new Blob([response.data], {
                    type: response.data.type
                });
                saveAs(blob, "media_download-"+moment().format('YYYY-MM-DD')+".csv");
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
	},
}
</script>
